import React from "react";
import { PaziaPrefixInput } from "components/atoms/Inputs";
import { TrainerFormHeader } from "./TrainerFormHeader";
import { TRAINER_FORM_FIELDS } from "./TrainerForm";
import { TRAINER_TITLES } from "consts/trainerTitles";
import { PaziaErrorMessage, PaziaInput, PaziaSelect } from "components/atoms";
import { useFieldArray, useFormContext } from "react-hook-form";
import { PaziaButton } from "components/atoms";
import { FaPlus, FaTrashAlt } from "react-icons/fa";
import { PAYMENT_TYPE_OPTIONS } from "consts";
import { useIsMobile } from "utils/hooks/useIsMobile";

export const TrainerFormLeft = (): JSX.Element => {
  const methods = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control: methods.control,
    name: TRAINER_FORM_FIELDS.PRICES,
  });
  const {
    formState: { errors },
  } = methods;
  const isMobile = useIsMobile();
  // Rate rows wrap on phones, so every row needs its own labels
  const showRateLabels = (index: number) => index === 0 || isMobile;

  return (
    <div className="md:grid md:grid-cols-3 gap-4 auto-rows-min">
      <TrainerFormHeader>Dane podstawowe</TrainerFormHeader>
      <PaziaSelect label="Tytuł" name={TRAINER_FORM_FIELDS.TITLE} options={TRAINER_TITLES} />
      <PaziaInput required label="Imię" name={TRAINER_FORM_FIELDS.FIRST_NAME} />
      <PaziaInput required label="Nazwisko" name={TRAINER_FORM_FIELDS.SURNAME} />

      <TrainerFormHeader>Komunikacja</TrainerFormHeader>
      <PaziaInput label="Telefon" name={TRAINER_FORM_FIELDS.PHONE} />
      <PaziaInput label="Email" name={TRAINER_FORM_FIELDS.EMAIL} />
      <PaziaInput label="Alternatywny email" name={TRAINER_FORM_FIELDS.ALTERNATIVE_EMAIL} />
      <PaziaInput className="col-span-3" label="Strona internetowa" name={TRAINER_FORM_FIELDS.WEBSITE} />
      <TrainerFormHeader>Lokalizacja</TrainerFormHeader>
      <div className="col-span-2">
        <PaziaInput label="Adres (Ulica, numer domu/lokalu)" name={TRAINER_FORM_FIELDS.ADDRESS} />
      </div>
      <PaziaInput label="Miasto" name={TRAINER_FORM_FIELDS.CITY} />
      <PaziaInput label="Kod pocztowy" name={TRAINER_FORM_FIELDS.POSTCODE} />
      <div className="col-span-2">
        <PaziaInput label="Paczkomat" name={TRAINER_FORM_FIELDS.INPOST} />
      </div>
      <TrainerFormHeader>Finanse</TrainerFormHeader>
      <div className="col-span-3 italic text-slate-500 text-sm md:-mt-4">
        Dodaj stawki za usługi trenera, zostaną one użyte do obliczenia ceny kursu.
      </div>
      {fields.map((field, index) => (
        <div key={field.id} className="flex flex-wrap col-span-3 gap-2 sm:flex-nowrap">
          <PaziaSelect
            name={`${TRAINER_FORM_FIELDS.PRICES}[${index}].${TRAINER_FORM_FIELDS.PRICES_TYPE}`}
            options={PAYMENT_TYPE_OPTIONS}
            isClearable={false}
            required
            label={showRateLabels(index) ? "Rodzaj rozliczenia" : undefined}
            className="w-full sm:w-40 sm:min-w-40"
          />
          <PaziaPrefixInput
            prefix="PLN"
            required
            label={showRateLabels(index) ? "Stawka" : undefined}
            className="w-28 sm:w-24 sm:min-w-24"
            name={`${TRAINER_FORM_FIELDS.PRICES}[${index}].${TRAINER_FORM_FIELDS.PRICES_AMOUNT}`}
          />
          <div className="flex min-w-0 flex-1">
            <PaziaInput
              required
              label={showRateLabels(index) ? "Nazwa" : undefined}
              name={`${TRAINER_FORM_FIELDS.PRICES}[${index}].${TRAINER_FORM_FIELDS.PRICES_NAME}`}
              className="grow"
            />
            <div className="flex items-center gap-2 mt-auto pb-[0.7rem] px-1">
              <FaTrashAlt
                size={16}
                className="text-slate-400 hover:text-black cursor-pointer"
                onClick={() => remove(index)}
              />
              <FaPlus
                className="text-slate-400 hover:text-black cursor-pointer"
                size={16}
                onClick={() => append({ name: "", type: 1, amount: 0 })}
              />
            </div>
          </div>
        </div>
      ))}
      <div className="col-span-3">
        {errors?.prices && <PaziaErrorMessage>Nazwa i wartość są wymagane.</PaziaErrorMessage>}
      </div>

      {fields.length < 1 && (
        <div className="col-span-3 mx-auto">
          <PaziaButton onClick={() => append({ name: "", type: 1, amount: 0 })} title="Dodaj stawkę" type={"primary"} />
        </div>
      )}
    </div>
  );
};
